import { useContext } from 'react';
import { ROIContext } from './ROIContext';

export const useROI = () => {
    const context = useContext(ROIContext);
    if (context === undefined) {
        throw new Error('useROI must be used within a ROIProvider');
    }
    return context;
};

export const useROIContext = useROI;
